export class ExamesDispositivosModel {
  id: number | string;
  nome: string;
  numero_serie: string;
}



// WEBPACK FOOTER //
// ./src/app/exames/dispositivos/exames-dispositivos.model.ts